import React from 'react';

import StockFilterMultiSelect from '@/components/StockFilterMultiSelect';
import { OptionType } from '@/typings/common';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarWheel,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  convertFilterParamsToOptionsByKey,
  handleChangeMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';

function WheelFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedWheel =
    useTypedSelector(getSelectedFilters).selectedParams.selectedWheel;

  const wheelOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'wheels'
  );

  const handleChangeWheel = (wheel: OptionType) => {
    dispatch(setCarWheel(handleChangeMultiSelect(wheel, selectedWheel)));
    dispatch(setPage(1));
  };

  const handleClearWheel = () => {
    dispatch(setCarWheel([]));
    dispatch(setPage(1));
  };

  return (
    <StockFilterMultiSelect
      label="Привод"
      options={wheelOptions}
      selectedOptions={selectedWheel}
      onChange={handleChangeWheel}
      onClear={handleClearWheel}
    />
  );
}

export default WheelFilter;
